var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
var cls = classNames('page-author');
import { breakpoints, theme } from '@shapeable/theme';
import { CellLabel } from '../elements/cell-label';
import { HTML } from '../elements/html';
import { useEntity } from '../hooks/use-entity';
import { filter, get, sortBy } from 'lodash';
import { useLang } from '../hooks/use-lang';
export var PageAuthorDefaultProps = {
  label: 'Written By:',
  showAllPositions: true
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-size: ", ";\n    color: ", ";\n    font-weight: 300;\n\n    b {\n      color: ", ";\n    }\n  "], ["\n    font-size: ", ";\n    color: ", ";\n    font-weight: 300;\n\n    b {\n      color: ", ";\n    }\n  "])), theme.FONT_SIZE(15), theme.COLOR('text'), theme.COLOR('strong'))
});
var LabelStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    font-weight: 300;\n    font-size: 1em;\n    color: ", ";\n    margin-bottom: ", ";\n  "], ["\n    font-weight: 300;\n    font-size: 1em;\n    color: ", ";\n    margin-bottom: ", ";\n  "])), theme.COLOR('text-subtle'), theme.UNIT(1))
});
var PersonStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    font-size: 1em;\n    margin-bottom: ", ";\n    display: block;\n  "], ["\n    font-size: 1em;\n    margin-bottom: ", ";\n    display: block;\n  "])), theme.UNIT(1.5))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Label: styled(CellLabel)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Person: styled(HTML)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), PersonStyles)
};
export var PageAuthor = function (props) {
  var className = props.className,
    children = props.children,
    label = props.label;
  var entity = useEntity(props.entity);
  // TODO - actually add an "Authors" and "Date" field!
  var published = entity.published,
    _a = entity.people,
    people = _a === void 0 ? [] : _a,
    _b = entity.authors,
    authors = _b === void 0 ? [] : _b;
  var t = useLang();
  var peopleToShow = __spreadArray(__spreadArray([], __read(authors), false), __read(people), false);
  if (!peopleToShow.length) {
    return null;
  }
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(My.Label, null, t(label)), peopleToShow.map(function (person) {
    var org = person && person.organisation;
    var position = person && person.position;
    var positions = sortBy(person && person.positions || [], function (position) {
      return position.primary ? 0 : 1;
    });
    var showAllPositions = props.showAllPositions && !!positions.length;
    var positionsToShow = showAllPositions ? positions.map(function (pos) {
      return filter([get(pos, 'positions[0].name', pos.position), pos.organisation && pos.organisation.name]).join(", ");
    }) : [filter([position, org && org.name]).join(", ")];
    if (!published && !person) {
      return null;
    }
    var parts = filter([person && person.name && "<b>".concat(person.name, "</b>"), positionsToShow.join('; ')]);
    if (!parts.length) {
      return null;
    }
    return React.createElement(My.Person, {
      key: person.slug,
      text: parts.join(', ')
    });
  }));
};
PageAuthor.defaultProps = PageAuthorDefaultProps;
PageAuthor.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;